import { FC, useMemo } from 'react';

import classNames from 'classnames';

import NavBarItem from '../NavBarItem';

import './Utility.scss';

import { TestMetadata } from '../../types';

export interface UtilityProps {
  /** Classname for site brand section */
  className?: string;
  /** TestMetadata for utility section - menu wrapper, menu */
  testMetadata?: TestMetadata;
}

export const Utility: FC<UtilityProps> = ({
  className,
  testMetadata,
  children,
}) => {
  const utilityClassNames = useMemo(
    () => classNames('sb-utility', className),
    [className],
  );

  return (
    <NavBarItem className={utilityClassNames} {...testMetadata}>
      {children}
    </NavBarItem>
  );
};

export default Utility;
